import type { CreditCardForm } from './CreditCardForm.types';

export const FADE_IN_DURATION = 500;
export const defaultCreditCardForm: CreditCardForm = {
  nickname: '',
  default: false,
};
